// @ts-check
import React from "react";
import { Form } from "react-bootstrap";

const FIELD_TYPE = {
  file: "file",
  image: "image",
};

/**
 * @param {{ index:number, field:any , handleChange:(params:{event:React.ChangeEvent<any>;isFile?:boolean;fieldType?:string})=>void ; errors:any,formData:any ; hideFieldManually?:boolean}} props
 * @returns {React.ReactElement}
 */

const GatewayFields = ({
  field,
  index,
  handleChange,
  errors,
  formData,
  hideFieldManually,
}) => {
  switch (field?.type) {
    case FIELD_TYPE.file:
    case FIELD_TYPE.image:
      return (
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
          key={index}>
          <Form.Control
            type={"file"}
            placeholder={field?.label}
            name={field?.accessor}
            onChange={(e) => handleChange({ event: e, isFile: true })}
            style={{
              display: !field?.display || hideFieldManually ? "none" : "",
            }}
            isInvalid={!!errors[field?.accessor]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors[field?.accessor]}
          </Form.Control.Feedback>
        </Form.Group>
      );
    default:
      return (
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName "
          key={index}>
          <Form.Control
            type={field?.type}
            placeholder={field?.label}
            name={field?.accessor}
            value={
              !Boolean(formData?.[field?.accessor]) &&
              formData?.[field?.accessor] !== "" &&
              field?.value
                ? field?.value
                : formData?.[field?.accessor]
            }
            onChange={(e) =>
              handleChange({ event: e, isFile: false, fieldType: field?.type })
            }
            style={{
              display: !field?.display || hideFieldManually ? "none" : "",
            }}
            isInvalid={!!errors[field?.accessor]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors[field?.accessor]}
          </Form.Control.Feedback>
        </Form.Group>
      );
  }
};
export default GatewayFields;
